import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button, Alert } from 'react-bootstrap';
import { getRequest, postRequest, deleteRequest } from '../../requestUtils';
import Loading from '../common/Loading';
import checkmarkImg from '../../../assets/images/check-mark.svg';
import infoIcon from '../../../assets/images/icons/blue-info-icon.svg';
import './InterviewQuestions.scss';
function InterviewQuestions(_ref) {
  var consultantName = _ref.consultantName,
    proposalResourceId = _ref.proposalResourceId,
    interviewQuestionsUrl = _ref.interviewQuestionsUrl,
    isConsultant = _ref.isConsultant,
    csrfToken = _ref.csrfToken;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    interviewQuestions = _useState2[0],
    setInterviewQuestions = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    loading = _useState4[0],
    setLoading = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    error = _useState6[0],
    setError = _useState6[1];
  var fetchQuestions = function fetchQuestions() {
    setLoading(true);
    setError('');
    getRequest(interviewQuestionsUrl, {
      resource_id: proposalResourceId
    }).then(function (_ref2) {
      var data = _ref2.data;
      setInterviewQuestions(data.interview_question);
      setLoading(false);
    })["catch"](function () {
      setError('Failed to load questions.');
      setLoading(false);
    });
  };
  useEffect(function () {
    fetchQuestions();
  }, []);
  var generateInterviewQuestions = function generateInterviewQuestions() {
    setLoading(true);
    setError('');
    postRequest(interviewQuestionsUrl, {
      resource_id: proposalResourceId
    }, csrfToken).then(function (_ref3) {
      var data = _ref3.data;
      setInterviewQuestions(data.interview_question);
      setLoading(false);
    })["catch"](function (e) {
      setError('Failed to load questions.', e);
      setLoading(false);
    });
  };
  var handleFeedbackClick = function handleFeedbackClick(index, vote) {
    var _interviewQuestions$f, _interviewQuestions$f2, _interviewQuestions$f3, _interviewQuestions$f4;
    var currentVote = (_interviewQuestions$f = interviewQuestions.feedback) === null || _interviewQuestions$f === void 0 ? void 0 : (_interviewQuestions$f2 = _interviewQuestions$f[index]) === null || _interviewQuestions$f2 === void 0 ? void 0 : _interviewQuestions$f2[0];
    var InterviewQuestionFeedbackId = (_interviewQuestions$f3 = interviewQuestions.feedback) === null || _interviewQuestions$f3 === void 0 ? void 0 : (_interviewQuestions$f4 = _interviewQuestions$f3[index]) === null || _interviewQuestions$f4 === void 0 ? void 0 : _interviewQuestions$f4[1];
    if (currentVote === vote) {
      deleteRequest("/interview_question_feedbacks/".concat(InterviewQuestionFeedbackId), csrfToken).then(function () {
        setInterviewQuestions(function (prev) {
          return _objectSpread(_objectSpread({}, prev), {}, {
            feedback: _objectSpread(_objectSpread({}, prev.feedback), {}, _defineProperty({}, index, [null, null]))
          });
        });
        setLoading(false);
      })["catch"](function (e) {
        setError('Failed to record feedback', e);
        setLoading(false);
      });
    } else {
      postRequest('/interview_question_feedbacks', {
        interview_question_id: interviewQuestions.id,
        question_index: index,
        feedback: vote
      }, csrfToken).then(function (_ref4) {
        var data = _ref4.data;
        setInterviewQuestions(function (prev) {
          return _objectSpread(_objectSpread({}, prev), {}, {
            feedback: data.feedback
          });
        });
        setLoading(false);
      })["catch"](function (e) {
        setError('Failed to record feedback', e);
        setLoading(false);
      });
    }
  };
  var renderFeedback = function renderFeedback(value, _onClick) {
    return /*#__PURE__*/React.createElement("div", {
      className: "d-flex align-items-center"
    }, /*#__PURE__*/React.createElement("span", {
      role: "button",
      tabIndex: 0,
      className: "bg-body-tertiary py-1 px-3 rounded-start-pill",
      onClick: function onClick() {
        return _onClick('up');
      },
      style: {
        cursor: 'pointer'
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "fa".concat(value === 'up' ? 's' : 'r', " fa-thumbs-up")
    })), /*#__PURE__*/React.createElement("div", {
      className: "vr"
    }), /*#__PURE__*/React.createElement("span", {
      role: "button",
      tabIndex: 0,
      className: "bg-body-tertiary py-1 px-3 rounded-end-circle",
      onClick: function onClick() {
        return _onClick('down');
      },
      style: {
        cursor: 'pointer'
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "fa".concat(value === 'down' ? 's' : 'r', " fa-thumbs-down")
    })));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "body-section interview-questions__container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "interview-header fw-bold text-center mb-3"
  }, isConsultant ? 'Get Ready for Your Interview' : "Interview Prep for ".concat(consultantName)), /*#__PURE__*/React.createElement("div", {
    className: "info-blurb mb-4"
  }, /*#__PURE__*/React.createElement("img", {
    src: infoIcon,
    alt: "info-icon"
  }), /*#__PURE__*/React.createElement("div", {
    className: "message"
  }, isConsultant ? /*#__PURE__*/React.createElement(Fragment, null, "These interview questions are generated using your profile information and the job you are applying for. They\u2019re designed to help you reflect on your fit, highlight your strengths, and prepare for potential interview topics.") : /*#__PURE__*/React.createElement(Fragment, null, "These interview questions are generated using the consultant\u2019s profile and the project details. They\u2019re designed to help you quickly identify alignment, uncover key discussion points, and streamline your evaluation process."))), loading && /*#__PURE__*/React.createElement(Loading, null), /*#__PURE__*/React.createElement("div", {
    className: "text-center"
  }, !loading && Object.keys(interviewQuestions).length === 0 && /*#__PURE__*/React.createElement(Button, {
    onClick: generateInterviewQuestions,
    variant: "primary",
    className: "mt-3"
  }, loading ? 'Generating...' : 'Generate Interview Questions')), !loading && Object.keys(interviewQuestions).length > 0 && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column gap-4 mt-3"
  }, interviewQuestions.questions.map(function (q, i) {
    var _interviewQuestions$f5, _interviewQuestions$f6;
    var _q$split = q.split('**'),
      _q$split2 = _slicedToArray(_q$split, 2),
      questionText = _q$split2[0],
      category = _q$split2[1];
    return /*#__PURE__*/React.createElement("div", {
      className: "d-flex gap-4 border-top pt-3",
      key: i
    }, /*#__PURE__*/React.createElement("div", {
      className: "d-none d-md-flex fw-bolder text-center question-number"
    }, "Question ".concat(i + 1)), /*#__PURE__*/React.createElement("div", {
      className: "question-text d-flex flex-column gap-2"
    }, /*#__PURE__*/React.createElement("div", null, questionText), /*#__PURE__*/React.createElement("div", {
      className: "d-flex justify-content-between align-items-center"
    }, /*#__PURE__*/React.createElement("div", {
      className: "fw-bolder border border-1 rounded-pill p-2 question-category bg-success-subtle"
    }, category), renderFeedback(interviewQuestions === null || interviewQuestions === void 0 ? void 0 : (_interviewQuestions$f5 = interviewQuestions.feedback) === null || _interviewQuestions$f5 === void 0 ? void 0 : (_interviewQuestions$f6 = _interviewQuestions$f5[i + 1]) === null || _interviewQuestions$f6 === void 0 ? void 0 : _interviewQuestions$f6[0], function (vote) {
      return handleFeedbackClick(i + 1, vote);
    }))));
  })), error && /*#__PURE__*/React.createElement(Alert, {
    variant: "danger",
    className: "mt-3 text-center"
  }, error)));
}
InterviewQuestions.propTypes = {
  interviewQuestionsUrl: PropTypes.string.isRequired,
  proposalResourceId: PropTypes.string.isRequired,
  isConsultant: PropTypes.bool.isRequired,
  csrfToken: PropTypes.string.isRequired
};
export default InterviewQuestions;